import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {select, Store} from '@ngrx/store';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {LicensedProduct} from '@shared/models/licsensed-product.model';

@Component({
    standalone: false,
    selector: 'particle-tax-forms-iframe-content',
  templateUrl: './tax-forms-iframe-content.component.html',
  styleUrls: ['./tax-forms-iframe-content.component.scss']
})
export class TaxFormsIframeContentComponent  implements OnInit , OnDestroy {

  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  accessToken: any;
  itrceUrl: SafeResourceUrl;
  testToken: string;
  token: string;
  itrceBaseUrl: string;
  authToken: any;
  constructor(
    private particleStore: Store<ParticleState>,
    private changeDetectorRef: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
  ) {}

  ngOnInit() {
    this.fuseSplashScreenService.show();
    this.particleStore.pipe(select(getApplicationWithId, 'ITCE')).subscribe(app => {
      if (app && app.HostUrl) {
        [this.itrceBaseUrl, this.authToken] = app.HostUrl.split('?');
        this.itrceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.itrceBaseUrl}?isCompact=True&${this.authToken}&appRelativeUrl=#/Forms`);
        // console.log('ITRCEBASE URL : ',this.itrceBaseUrl);
        setTimeout( () => {
          this.changeDetectorRef.detectChanges();
          this.checkIframeLoad('itpTaxForms');
        }, 100);
      }
    }, err => {
      this.snackBarService.showError('Can\'t show Forms');
      this.fuseSplashScreenService.hide();
      console.log('Forms ', err);
    });
  }

  ngOnDestroy() {}

  private checkIframeLoad(frameId: string) {
    const frame = <HTMLIFrameElement>document.getElementById(frameId);
    frame.addEventListener('load', () => {
      console.log('loaded');
      this.fuseSplashScreenService.hide();
    });
  }
}
